import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider } from '@mui/material';
import classes from './RatingHighlights.module.scss';
import { GET_RATING_REVIEWS_REQUEST } from '../../../../../redux/actions';
import {
  L12M,
  L3060D,
  L30D,
  N30D,
} from '../../../../../utils/constants/filterConstants';

import { isNumber } from '../../../../../utils/commonUtils';
import { Highlight } from '../../../../common/BasicHighlight/BasicHighlight';
import {
  ratingErrorSelector,
  ratingLoadingSelector,
  ratingSelector,
} from '../../../../../redux/selectors/ratingSelector';
import { Loader } from '../../../../common/Loader/Loader';
import { userDataSelector } from '../../../../../redux/selectors/userDataSelector';
import { Typography } from '../../../../../shared/ui/typography';
import { isMobileModeSelector } from '../../../../../redux/selectors/appStatusSelector';
import { ratingReviewsSelector } from '../../../../../redux/selectors/ratingReviewsSelector';

import { listingsSelector } from '@/redux/selectors/listingsSelector';
import { IListing } from '@/views/interfaces';
import { useMemo } from 'react';


export const periodList = [
  {
    id: L30D,
    label: L30D,
  },
  {
    id: L12M,
    label: L12M,
  },
];

interface IRatingHighlights {
  period: string;
}

export const RatingHighlights = ({ period }: IRatingHighlights) => {
  const dispatch = useDispatch();
  const isMobileView = useSelector(isMobileModeSelector);
  const ratingData = useSelector(ratingReviewsSelector(period))?.summary?.[0];

  const listings: IListing[] = useSelector(listingsSelector);
  const body = useMemo(() => {
    return (listings !== null ? listings : [])
      .filter((listing) => listing.is_listed)
      .map((listing) => listing.property_id);
  }, [listings]);

  var cleanliness_rating = null;
  var cleanliness_rating_previous = null;
  var number_of_reviews = null;
  var number_of_reviews_previous = null;
  var overall_rating = null;
  var overall_rating_previous = null;
  var value_rating = null;
  var value_rating_previous = null;
  if(period == "last 12 months")
  {
    cleanliness_rating = ratingData?.cleanliness_rating_L12M;
    cleanliness_rating_previous = ratingData?.cleanliness_rating_L30_60D;
    number_of_reviews = ratingData?.number_of_reviews_L12M;
    number_of_reviews_previous = ratingData?.number_of_reviews_L30_60D;
    overall_rating = ratingData?.overall_rating_L12M;
    overall_rating_previous = ratingData?.overall_rating_L30_60D;
    value_rating = ratingData?.value_rating_L12M;
    value_rating_previous = ratingData?.value_rating_L30_60D;
  }else{
    cleanliness_rating = ratingData?.cleanliness_rating_L30D;
    cleanliness_rating_previous = ratingData?.cleanliness_rating_L30_60D;
    number_of_reviews = ratingData?.number_of_reviews_L30D;
    number_of_reviews_previous = ratingData?.number_of_reviews_L30_60D;
    overall_rating = ratingData?.overall_rating_L30D;
    overall_rating_previous = ratingData?.overall_rating_L30_60D;
    value_rating = ratingData?.value_rating_L30D;
    value_rating_previous = ratingData?.value_rating_L30_60D;
  }
  

  const isLoading = useSelector(ratingLoadingSelector);
  const isError = useSelector(ratingErrorSelector);

  useEffect(() => {
    dispatch({
      type: GET_RATING_REVIEWS_REQUEST,
      payload: body,
    });
  }, [dispatch, body]);

  // reservations cheking for pricelabs
  
  // Conditional check to hide content if source is "Pricelabs"
  const userData = useSelector(userDataSelector);

  if (userData && userData.source === 'pink') {
    return null;
  }

  return (
    <div className={classes.ratingHighlightsWrapper}>
      <>
        <div className={classes.ratingHighlightsHeader}>
          <Typography
            variant={isMobileView ? 'text-md' : 'text-xl'}
            weight='medium'
            className={classes.gray900}
          >
            Rating
          </Typography>
        </div>
        <Loader isLoading={isLoading} isError={isError} data={ratingData} />
        {ratingData && (
          <div className={classes.highlights}>
            {isNumber(overall_rating) && (
              <>
                <Highlight
                  label='Overall Rating'
                  rating
                  tooltip={
                    'This is the average score given to your property compared to every other property listed on Online Travel Agencies, Airbnb and Booking.com. This number takes into account your property’s cleanliness, value, location, listing accuracy, staff, facilities, communication, check-in simplicty and comfort'
                  }
                  value={overall_rating}
                  previousValue={overall_rating_previous}
                  showDynamicIndicator={period !== L30D}
                  isDecimal
                />
              </>
            )}
            {isNumber(value_rating) && (
              <>
                <Highlight
                  label='Value'
                  rating
                  tooltip={''} //TODO: ask for text
                  value={value_rating}
                  previousValue={value_rating_previous}
                  showDynamicIndicator={period !== L30D}
                  isDecimal
                />
              </>
            )}
            {isNumber(cleanliness_rating) && (
              <>
                <Highlight
                  label='Cleanliness'
                  rating
                  tooltip={''} //TODO: ask for text
                  value={cleanliness_rating}
                  previousValue={cleanliness_rating_previous}
                  showDynamicIndicator={period !== L30D}
                  isDecimal
                />
              </>
            )}
            {isNumber(Number(number_of_reviews)) && (
              <Highlight
                label='Number of Reviews'
                tooltip={''} //TODO: ask for text
                value={number_of_reviews}
                previousValue={number_of_reviews_previous}
                showDynamicIndicator={period !== L30D}
              />
            )}
          </div>
        )}
      </>
    </div>
  );
};
